//
//
//
//
//
//
//
//
//
//
//
//
//
import newUserPaid from "./userPaymentTieredPenetrationRate/newUserPaid";
import levelPaymentAmount from "./userPaymentTieredPenetrationRate/levelPaymentAmount";
import levelPaymentFrequency from "./userPaymentTieredPenetrationRate/levelPaymentFrequency";
export default {
  name: "userPaymentTieredPenetrationRate",
  components: {
    newUserPaid: newUserPaid,
    levelPaymentAmount: levelPaymentAmount,
    levelPaymentFrequency: levelPaymentFrequency
  },
  mixins: [],
  data: function data() {
    return {
      activeIndex: 'newUserPaid'
    };
  },
  created: function created() {},
  activated: function activated() {},
  methods: {
    handover: function handover(index) {
      this.activeIndex = index;
    }
  }
};